moment = require("moment")

BasicAnalysisCtrl = ($scope, $filter, ScoreCardAPIService, GoalAPIService, DashboardBasicAnalysisService, cache) ->
  $scope.isLoading = false
  $scope.basicAnalysisData =
    goal: undefined
    my_avg: undefined
    all_members: undefined

  callMyAnalysis = (params = {}) ->
    $scope.isLoading = true
    DashboardBasicAnalysisService.getMyAnalysis(params)
      .then (res) ->
        $scope.basicAnalysisData.my_avg = res.data
      .finally ->
        $scope.isLoading = false

  createMyAnalysisParams = ->
    from: $scope.startDate
    to: $scope.endDate
    round_type: $scope.roundType

  # load data
  ScoreCardAPIService.getAllMembers().then (data) ->
    $scope.basicAnalysisData.all_members = data
  GoalAPIService.getGoalSettings().then (res) ->
    $scope.basicAnalysisData.goal = res

  $scope.$on "periodSelected.gnp.dashboard", (event, startDate, endDate, roundType) ->
    $scope.startDate = startDate?.clone()
    $scope.endDate = endDate?.clone()
    $scope.roundType = roundType
    params = createMyAnalysisParams()
    callMyAnalysis(params)

  $scope.$on "roundTypeUpdated.gnp.dashboard", (event, roundType) ->
    $scope.roundType = roundType
    params = createMyAnalysisParams()
    callMyAnalysis(params)

BasicAnalysisCtrl.$inject = [
  '$scope'
  '$filter'
  'ScoreCardAPIService'
  'GoalAPIService'
  'DashboardBasicAnalysisService'
  'cache'
]

module.exports = BasicAnalysisCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/basic-analysis/basic-analysis-controller.coffee